module.exports = require("@microsoft/applicationinsights-react-js");